import Svg from "../../../../../../ui library/components/svgs/standard/svg";
import {Typography} from "@mui/material";

const CardHeader = ({title, icon}) => {
  return (
    <div
      className="p-2 gap-2 flex items-center border-slate-200 text-md text-center text-black w-full py-2 bg-white"
      style={{
        borderBottom: '3px solid #cdd4de',
        marginBottom: '1.1rem',
    }}
    >
      {icon && <Svg name={icon} color='#247DF8' sx={{width: '29px'}}/>}
      <Typography style={{fontFamily: 'Roboto', fontSize: '24px'}}>
        {title}
      </Typography>
    </div>
  );
};

export default CardHeader;
